module.exports = __webpack_public_path__ + "img/logo.47425404.svg";